module.exports = __webpack_public_path__ + "img/marketplace.23763de7.jpeg";